import type { ModalOptions } from 'flowbite'

export const defaultModalOptions: ModalOptions = {
  placement: 'center',
  backdrop: 'dynamic',
  backdropClasses: 'backdrop',
  closable: true
}
